import { type ReactNode,useEffect, useState } from "react";

import { en, pt } from "@/locales";

import { I18nContext, ILocale,ITranslations } from "./i18n-context";

const translations: ITranslations = {
  "pt-BR": pt,
  "en-US": en,
};

export function I18nProvider({ children }: { children: ReactNode }) {
  const [locale, setLocale] = useState<ILocale>("en-US");

  useEffect(() => {
    const savedLocale = localStorage.getItem("locale") as ILocale | null;
    if (savedLocale && (savedLocale === "pt-BR" || savedLocale === "en-US")) {
      setLocale(savedLocale);
    } else {
      const browserLocale = navigator.language;
      if (browserLocale.startsWith("pt")) {
        setLocale("pt-BR");
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("locale", locale);
  }, [locale]);

  const t = (key: string): string => {
    return translations[locale]?.[key] || key;
  };

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
}
